import Vue from 'vue'
import VueRouter from 'vue-router'
import { authGuard } from './guards/auth-guard'
import routes from './routes'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

/**
 * Attach auth check to router
 */
router.beforeEach(authGuard)

export default router
